import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NewAboutUs.css';
import SignTest from '../../assets/events/PRX_sign.jpg';
import MetricsBanner from '../../components/Banner/MetricsBanner';
import TimelineSection from '../../components/NewTimeline/NewTimeline';
import AboutUsBanner from '../../components/Banner/AboutUsBanner';

const AboutUs = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.substring(1); // Get rid of the '#' in the hash
    if (hash) {
      const section = document.getElementById(hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div id="who-we-are" className="newaboutus-page">
      {/* Helmet for SEO and meta information */}
      <Helmet>
        <title>About Pharm-Rx: Our Story, Mission & Team</title>
        <meta 
          name="description" 
          content="Learn about Pharm-Rx's journey since 1991. Discover our mission, values, and the dedicated team behind our success in the pharmaceutical and health industry." 
        />
        <meta property="og:title" content="About Pharm-Rx: Our Story and Mission" />
        <meta 
          property="og:description" 
          content="Learn about Pharm-Rx's journey since 1991. Discover our mission, values, and the dedicated team behind our success in the pharmaceutical and health industry." 
        />
        <meta property="og:url" content="https://www.pharm-rxchem.com/about" />
        <meta property="og:site_name" content="Pharm-Rx" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "Pharm-Rx",
            "url": "https://www.pharm-rxchem.com",
            "description": "Learn about Pharm-Rx's journey since 1991. Discover our mission, values, and the dedicated team behind our success in the pharmaceutical and health industry.",
            "sameAs": [
              "https://www.linkedin.com/company/pharm-rx-chemical-corp",
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+1-973-917-1400",
              "contactType": "Customer Service",
              "availableLanguage": ["English"]
            }
          })}
        </script>
      </Helmet>
      <div className="newaboutus-container newaboutus-section">
        <div className="newaboutus-heading-container">
          <h2 className="newaboutus-heading">Who We Are</h2>
        </div>
        <div className="newaboutus-paragraph-container">
          <p className="newaboutus-paragraph">
            Since 1991, Pharm-Rx has been a trusted importer and distributor of high-quality active ingredients for the pharmaceutical, nutraceutical, personal care, and food industries. Our commitment to selective partnerships, competitive pricing, and outstanding customer service drives our continued success and growth.
          </p>
        </div>
      </div>
      <div className="newaboutus-container newaboutus-image-section">
        <div className="newaboutus-image-wrapper">
          <img 
            loading="lazy"
            className="newaboutus-image"
            src={SignTest}
            alt="Pharm-RX hosted event"
          />
        </div>
      </div>
      <MetricsBanner />
      <div id="our-story">
        <TimelineSection />
      </div>
      <AboutUsBanner />
    </div>
  );
};

export default AboutUs;
